/**
 * Desktop Login Handler
 * Uses externalized config and validation modules
 */

import './main.js';
import { getLoginPassword } from './config.js';
import { validatePassword, isLockedOut, recordFailedAttempt, resetAttempts, getLockoutRemainingSeconds } from './validation.js';
import { startTimeUpdater, isMobileDevice, redirectByDevice } from './utils.js';

/**
 * Initializes the login form handlers
 */
async function initLoginForm() {
  const form = document.getElementById('loginForm');
  const passwordInput = document.getElementById('password');
  const errorMsg = document.getElementById('errorMsg');

  if (!form || !passwordInput || !errorMsg) {
    console.error('[Login] Required elements not found');
    return;
  }

  // Get password from config
  let correctPassword;
  try {
    correctPassword = await getLoginPassword();
  } catch (error) {
    console.error('[Login] Failed to load config:', error);
    errorMsg.textContent = 'Konfigurationsfehler. Bitte Seite neu laden.';
    return;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Check lockout
    if (isLockedOut()) {
      const remaining = getLockoutRemainingSeconds();
      errorMsg.textContent = `Zu viele Versuche. Bitte warten Sie ${remaining} Sekunden.`;
      return;
    }

    const inputPassword = passwordInput.value;

    if (validatePassword(inputPassword, correctPassword)) {
      // Success
      resetAttempts();
      redirectByDevice('./mobile-desktop.html', './desktop.html');
    } else {
      // Failure
      const result = recordFailedAttempt();

      if (result.isLocked) {
        errorMsg.textContent = `Zu viele Versuche. Bitte warten Sie ${result.lockoutSeconds} Sekunden.`;
      } else {
        errorMsg.textContent = `Falsches Passwort! (${result.remainingAttempts} Versuche übrig)`;
      }

      passwordInput.value = '';
      passwordInput.focus();
    }
  });
}

/**
 * Handles device detection and redirect
 */
function handleDeviceRedirect() {
  if (isMobileDevice()) {
    const currentPath = window.location.pathname;
    if (currentPath.includes('index.html') || currentPath.endsWith('/')) {
      window.location.href = './mobile.html';
      return true;
    }
  }
  return false;
}

/**
 * Initialize login page
 */
async function init() {
  // Redirect mobile users
  if (handleDeviceRedirect()) {
    return;
  }

  // Start time updater if element exists
  const timeElement = document.getElementById('taskbar-time');
  if (timeElement) {
    startTimeUpdater('taskbar-time');
  }

  // Initialize login form
  await initLoginForm();

  console.log('[Login] Initialized');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

export { init, initLoginForm, handleDeviceRedirect };
